var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-range-picker',{attrs:{"date-range":_vm.model,"opens":"right","ranges":_vm.ranges,"min-date":_vm.minDate,"max-date":_vm.maxDate},on:{"start-selection":_vm.updateDateBounds,"finish-selection":_vm.clearDateBounds,"update":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }